module.exports = __webpack_public_path__ + "know-my-power/know-my-power-2bb0e55d91aba61040141eff4d6c0c6c.svg";